import { useMutation } from "@tanstack/react-query";
import { signup } from "@/adapters/api";

export function useSignup() {
	return useMutation({ mutationFn: signup });
}
